import React from 'react';
import { DisclosureButton, DisclosurePanel } from '@headlessui/react';
import Link from 'next/link';
import { WithTranslation } from 'next-i18next';
import { withTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { getClassNameForMobile } from '../../nav-helpr';

interface Props extends WithTranslation {
  t: any;
  handleLogout: () => void;
}

const TutorHeaderMobile: React.FC<Props> = ({ t, handleLogout }: Props) => {
  const { pathname: currentPath } = useRouter();
  return (
    <DisclosurePanel className="md:hidden">
      {({ close }) => (
        <div className="pt-2 pb-3 space-y-1">
          {/* Current: "bg-indigo-50 border-indigo-500 text-indigo-700", Default: "border-transparent text-default hover:bg-gray-50 hover:border hover:text-gray-700" */}
          <DisclosureButton as={Link} href="/t/dashboard">
            <a
              className={getClassNameForMobile('/t/dashboard', currentPath)}
              onClick={() => close()}
            >
              {t('service.header.dashboard')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href="/t/materials">
            <a
              className={getClassNameForMobile('/t/materials', currentPath)}
              onClick={() => close()}
            >
              {t('service.header.materials')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href="/messages">
            <a
              className={getClassNameForMobile('/messages', currentPath)}
              onClick={() => close()}
            >
              {t('links.messenger')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href="/t/profile/edit">
            <a
              className={getClassNameForMobile('/t/profile/edit', currentPath)}
              onClick={() => close()}
            >
              {t('links.editProfile')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href="/t/sync-cal">
            <a
              className={getClassNameForMobile('/t/sync-cal', currentPath)}
              onClick={() => close()}
            >
              {t('links.syncCalendar')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={React.Fragment}>
            <a
              className="border-transparent text-default px-1 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
              onClick={() => {
                handleLogout();
                close();
              }}
            >
              {t('links.logout')}
            </a>
          </DisclosureButton>
        </div>
      )}
    </DisclosurePanel>
  );
};

const wrapped = withTranslation('common')(TutorHeaderMobile);

export default wrapped;
